import { useMatches } from "@tanstack/react-router";
import { useMemo } from "react";

import { usePageTitleOverrideValue } from "@/providers/hooks/use-page-title-override";

/** i18n key of the deepest matched route that declares a title. */
export const useStaticPageTitle = () => {
    const matches = useMatches();

    return useMemo(() => {
        return matches.reduceRight((foundTitle, match) => {
            if (foundTitle) return foundTitle;

            const config = match.staticData?.config;
            return config?.title ?? config?.breadcrumb?.title ?? config?.sidebar?.label ?? "";
        }, "");
    }, [matches]);
};

export const usePageTitle = () => {
    const staticTitle = useStaticPageTitle();
    const override = usePageTitleOverrideValue();

    if (override) {
        return { title: override, translate: false };
    }

    return { title: staticTitle, translate: true };
};
